<template>
  <div
    ref="cardEl"
    class="card-dynamic portrait"
    :style="{
      ...cardElVarStyles,
      ...cardDynamicElVarStyles,
      ...cardElStyles,
    }"
  >
    <div
      class="media-container"
      v-if="parentGeneral.showCardsMedia"
      :class="
        parentGeneral.imageProportions?.value !== 'default'
          ? '-prefer-ratio'
          : ''
      "
    >
      <slot name="media" />
    </div>

    <div class="content-container">
      <div class="header-text-container">
        <slot name="header" />
        <slot name="text" />
      </div>

      <div class="button-container">
        <slot name="ctaButton" />
      </div>
    </div>
  </div>
</template>

<script>
import { cardComputed, cardProps } from "../mixins/card";

export default {
  name: "CardDynamic",
  mixins: [cardComputed, cardProps],
  computed: {
    cardDynamicElVarStyles() {
      const { showCardsMedia } = this.parentGeneral;

      return {
        "--media-container-height": showCardsMedia ? "350px" : "0px",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/shared";
@import "../scss/portrait";

.card-dynamic {
  --media-container-height: 350px;
}

.media-container {
  height: var(--media-container-height);
}
</style>
